export class Chat {
    constructor(options = {}) {
        if(!document.querySelector('.chat')) {
            return;
        }
        this.chatElement = options.chatElement || document.querySelector('.chat');
        this.messageInput = options.messageInput || document.querySelector('#chat-message-input');
        this.sendButton = options.sendButton || this.chatElement.querySelector('#send_button');
        this.attachButton = options.attachButton || this.chatElement.querySelector('#attach_button');
        this.inputFile = options.inputFile || this.chatElement.querySelector('input[type="file"]');
        this.messageHistory = options.messageHistory || document.querySelector('.chat_history');
        this.formSubmissionId = parseInt(this.chatElement.getAttribute('data-form-submission-id'));
        this.ajaxUrl = window.docuswiftPortal?.ajax_url || '/wp-admin/admin-ajax.php';
        this.nonce = window.docuswiftPortal?.nonce || '';
        this.chatId = parseInt(this.chatElement.getAttribute('data-chat-id'));
        this.messageCount = parseInt(this.chatElement.getAttribute('data-message-count')) || 0;
        this.isSendingMessage = false;
        this.tabVisibility = true;
    }

    init() {

        if(!document.querySelector('.chat')) {
            return;
        }
        this.setupEventListeners();
        return this;
    }

    sendMessage() {
        const message = this.messageInput.value.trim();
        if (!message) return;
        
        // Don't check for new messages while sending - it causes race conditions
        // this.checkForNewMessages();
        this.isSendingMessage = true;

        // Create a container for the new message, similar to PHP output
        const roleClass = 'sender-user'; // Default to sender-user, adjust as needed
        const messageDiv = document.createElement('div');
        messageDiv.className = `chat_history__item my_message message_loading ${roleClass}`;

        // Add message HTML (wrap with <p> for consistency with wpautop)
        const p = document.createElement('p');
        // Replace new lines with <br>
        const messageWithLineBreaks = message.replace(/\n/g, '<br>');
        p.innerHTML = messageWithLineBreaks;
        messageDiv.appendChild(p);

        // Add time label
        const span = document.createElement('span');
        span.className = 'time';
        const now = new Date();
        span.textContent = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
        messageDiv.appendChild(span);

        // Append to chat history
        this.messageHistory.appendChild(messageDiv);

        // Scroll to bottom
        this.messageHistory.scrollTop = this.messageHistory.scrollHeight;

        // Clear input
        this.messageInput.value = '';
        this.autoResizeTextarea();

        // Send AJAX request using standard WordPress URL-encoded format for normalization
        const formData = new URLSearchParams();
        formData.append('action', 'docuswift_portal_chat_send_message');
        formData.append('message', message);
        formData.append('form_submission_id', this.formSubmissionId);
        formData.append('chat_id', this.chatId);
        formData.append('nonce', this.nonce);

        fetch(this.ajaxUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData.toString()
        })
        .then(response => response.json())
        .then(response => {
            this.isSendingMessage = false;
            if(response.success) {
                messageDiv.classList.remove('message_loading');
                document.querySelector('.chat_history__empty')?.remove();
                // Update message count after sending - increment locally for immediate sync
                this.messageCount += 1;
                // Also update from server response if provided (for accuracy)
                // if (response.data.message_count !== undefined) {
                //     this.messageCount = parseInt(response.data.message_count);
                // }
                // Check for new messages after sending
                this.checkForNewMessages(true);
            } else {
                messageDiv.remove();
                alert(response.data.error_message);
            }
        })
        .catch(error => {
            this.isSendingMessage = false;
            messageDiv.remove();
            alert('Failed to send message. Please try again.');
            console.error('Error sending message:', error);
        });
    }
    checkForNewMessages(automaticallyReloadChat = false) {
        if(this.isSendingMessage) {
            return;
        }
        // console.log('this.messageHistory.scrollTop: ', this.messageHistory.scrollTop);
        // console.log('this.messageHistory.scrollHeight: ', this.messageHistory.scrollHeight);
        // Use a tolerance to check if user is scrolled to (or very near) the bottom of chat history
        const tolerance = 200; // pixels
        // console.log(Math.abs((this.messageHistory.scrollTop + this.messageHistory.clientHeight) - this.messageHistory.scrollHeight) <= tolerance);
        if (Math.abs((this.messageHistory.scrollTop + this.messageHistory.clientHeight) - this.messageHistory.scrollHeight) <= tolerance) {
            automaticallyReloadChat = true;
        }
        
        const formData = new URLSearchParams();
        formData.append('action', 'docuswift_portal_chat_check_for_new_messages');
        formData.append('chat_id', this.chatId);
        formData.append('form_submission_id', this.formSubmissionId);
        formData.append('message_count', this.messageCount);
        formData.append('nonce', this.nonce);
        
        fetch(this.ajaxUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData.toString()
        })
        .then(response => response.json())
        .then(response => {
            // Update message count to keep it in sync
            if (response.data.message_count !== undefined) {
                const previousCount = this.messageCount;
                this.messageCount = parseInt(response.data.message_count);
                
                if(response.data.is_there_new_messages) {
                    if(automaticallyReloadChat) {
                        this.reloadChat();
                    } else {
                        document.querySelector('#load_new_messages_btn').classList.remove('hidden');
                    }
                }
                
            }
        })
        .catch(error => {
            console.error('Error checking for new messages:', error);
        });
    }

    reloadChat() {
        document.querySelector('#load_new_messages_btn').classList.add('hidden');
        document.querySelector('.chat_history').classList.add('loading');
        const formData = new URLSearchParams();
        formData.append('action', 'docuswift_portal_chat_reload_chat');
        formData.append('chat_id', this.chatId);
        formData.append('form_submission_id', this.formSubmissionId);
        formData.append('nonce', this.nonce);
        fetch(this.ajaxUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: formData.toString()
        })
        .then(response => response.json())
        .then(response => {
            if(response.success && response.data.messages_html) {
                const chatHistory = document.querySelector('.chat_history');
                if (chatHistory) {
                    chatHistory.parentNode.removeChild(chatHistory);
                }
                // Update message count after reloading
                if (response.data.message_count !== undefined) {
                    this.messageCount = parseInt(response.data.message_count);
                }
                // Insert the new HTML after h4
                const chatHeader = document.querySelector('.chat h4');
                if (chatHeader) {
                    chatHeader.insertAdjacentHTML('afterend', response.data.messages_html);
                }
                this.messageHistory = document.querySelector('.chat_history');
                this.messageHistory.scrollTop = this.messageHistory.scrollHeight;
                this.setupChatHistoryAjax();
            }
        });
    }

    loadMoreMessages() {
        const latestMessageId = this.messageHistory.querySelector('.chat_history .chat_history__item').getAttribute('data-message-id');
        const formData = new URLSearchParams();
        formData.append('action', 'docuswift_portal_chat_load_more_messages');
        formData.append('chat_id', this.chatId);
        formData.append('latest_message_id', latestMessageId);
        formData.append('form_submission_id', this.formSubmissionId);
        formData.append('nonce', this.nonce);
        // setTimeout(() => {

            fetch(this.ajaxUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: formData.toString()
            })
            .then(response => response.json())
            .then(response => {
                if(response.success && response.data.messages_html) {
                    const chatHistory = document.querySelector('.chat_history');
                    if (chatHistory) {
                        // Save current scroll position relative to bottom
                        chatHistory.scrollTop = 0;
                        const prevScrollFromBottom = chatHistory.scrollHeight - chatHistory.scrollTop;
                        console.log('prevScrollFromBottom: ', prevScrollFromBottom);

                        // Create a temporary container to parse the new HTML
                        const tempDiv = document.createElement('div');
                        tempDiv.innerHTML = response.data.messages_html;
                        // Find new message items
                        const newMessages = tempDiv.querySelectorAll('.chat_history__item, .date');
                        // Prepend new messages to the beginning of chatHistory
                        for (let i = newMessages.length - 1; i >= 0; i--) {
                            chatHistory.insertBefore(newMessages[i], chatHistory.firstChild);
                        }

                        // Restore scroll position so the view stays where it was
                        chatHistory.scrollTop = chatHistory.scrollHeight - prevScrollFromBottom;
                    }
                    this.messageHistory = document.querySelector('.chat_history');
                }
                console.log(response);
            });

        // }, 3000);
    }

    autoResizeTextarea() {
        this.messageInput.style.height = 'auto';
        this.messageInput.style.height = this.messageInput.scrollHeight + 'px';
    }

    setupEventListeners() {
        ['change', 'input', 'keyup'].forEach(event => {
            this.messageInput.addEventListener(event, (e) => {
                e.preventDefault();
                this.autoResizeTextarea();
            });
        });
        this.sendButton.addEventListener('click', (e) => {
            e.preventDefault();
            this.sendMessage();
        });
        this.attachButton.addEventListener('click', (e) => {
            e.preventDefault();
            // this.inputFile.files = '';
            this.inputFile.click();
        });
        document.addEventListener("visibilitychange", () => {
            this.tabVisibility = !document.hidden;
            clearInterval(this._chatInterval);
            if(this.tabVisibility) {
                this.checkForNewMessages(true);
                this._chatInterval = setInterval(() => {
                    this.checkForNewMessages();
                }, 30000);
            }
        });

        // Setup polling interval based on initial visibility
        this._chatInterval = setInterval(() => {
            this.checkForNewMessages();
        }, 30000);
        document.querySelector('#load_new_messages_btn').addEventListener('click', (e) => {
            e.preventDefault();
            this.reloadChat();
        });
        this.setupChatHistoryAjax();
    }

    setupChatHistoryAjax() {
        const chatHistory = document.querySelector('.chat_history');
        if (chatHistory) {
            chatHistory.addEventListener('scroll', (e) => {
                // If scrolled to top (beginning), fire alert
                if (chatHistory.scrollTop === 0) {
                    this.loadMoreMessages();
                    // alert("You've reached the top of the chat history!");
                }
            });
        }
    }
    
}